module.exports = __webpack_public_path__ + "static/SewMasks-4e374d4c298a642994fd4ac397a05cab.png";